
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanySuggestionsResource,
} from '../models';
import {
    CompanySuggestionsResourceFromJSON,
    CompanySuggestionsResourceToJSON,
} from '../models';

export interface SuggestCompanyRequest {
    q: string;
    cache?: boolean;
}

/**
 * 
 */
export class SuggestCompaniesApi extends runtime.BaseAPI {

    /**
     * Suggest company according to free text provided
          */
    async suggestCompanyRaw(requestParameters: SuggestCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CompanySuggestionsResource>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling suggestCompany().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['cache'] != null) {
            queryParameters['cache'] = requestParameters['cache'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CompanySuggestionsResource>({
            path: `/profile/public-api/suggest/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CompanySuggestionsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Suggest company according to free text provided
          */
    async suggestCompany(requestParameters: SuggestCompanyRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CompanySuggestionsResource> {
        const response = await this.suggestCompanyRaw(requestParameters, initOverrides);
        return response._data;
    }

}
